import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import ModalGenericPostCancelContainer from "../../../Common/ModalGenericPostCancelContainer";

import { getMiljogebyr as getMiljogebyrAction } from "../../../../actions/miljogebyrerActions";
import { deleteMiljoMakulering as deleteMiljoMakuleringAction } from "../../../../actions/miljoMakuleringerActions";

import { getMostRecentObjectComparedOnParameter } from "../../../../utils/date";

export default function OpphevMakuleringContainer({ reloadHistorikk }) {
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const mostRecentMakulering = useSelector(
    (state) =>
      state.miljoMakuleringer &&
      getMostRecentObjectComparedOnParameter(
        state.miljoMakuleringer,
        "makuleringDato",
      ),
  );
  const dispatch = useDispatch();

  const getMiljogebyr = (id) => dispatch(getMiljogebyrAction(id));
  const deleteMiljoMakulering = (id) =>
    dispatch(deleteMiljoMakuleringAction(id));

  const handleApiCall = async (makuleringId) => {
    return deleteMiljoMakulering(makuleringId)
      .then(() => {
        getMiljogebyr(miljogebyr.id);
        reloadHistorikk();
        return Promise.resolve();
      })
      .catch((error) => Promise.reject(error));
  };

  const showOpphevMakulering = () => {
    if (!miljogebyr.isMakulert) return false;
    if (!mostRecentMakulering) return false;
    if (miljogebyr.id !== mostRecentMakulering.miljogebyrId) return false;
    return true;
  };

  if (showOpphevMakulering()) {
    return (
      <ModalGenericPostCancelContainer
        id={mostRecentMakulering.id}
        submitButtonText="Opphev makulering"
        submittingButtonText="Opphever makulering..."
        successPostCallFlashMessage="Endring vellykket"
        errorPostCallFlashMessage="Endring feilet"
        handleApiCall={handleApiCall}
        modalTitle={`Opphev makulering for miljogebyr  ${miljogebyr.ileggelsesnummer}`}
        openModalComponentFunction={(props) => (
          <Button
            className="btn btn-bym-standard"
            style={{ marginLeft: 20 }}
            onClick={props.openModal}
          >
            Opphev makulering
          </Button>
        )}
      >
        <p>{`Vil du oppheve makulering av miljøgebyr ${miljogebyr.ileggelsesnummer}?`}</p>
      </ModalGenericPostCancelContainer>
    );
  }
  return <span />;
}

OpphevMakuleringContainer.propTypes = {
  reloadHistorikk: PropTypes.func,
};
